import { useState } from 'react'
import { Link } from 'react-router-dom'

export default function ProductCard({ product }) {
  const [failed, setFailed] = useState(false)
  return <article className="product-card"><Link to={`/products/${product.id}`} aria-label={`查看${product.name}详情`}>
    <div className="product-image">{failed ? <div className="image-fallback">暂无图片</div> : <img src={product.image} alt={`${product.name}产品图`} loading="lazy" width="440" height="296" onError={() => setFailed(true)} />}</div>
    <h3>{product.name}</h3>
  </Link></article>
}
